import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
    MainContainer,
    LeftContainer,
    RightContainer
} from "src/scenes/Chat/components/styled/shared";
import {
    CompanyLogoContainer,
    ChatListScrollableContainer
} from "src/scenes/Chat/components/styled/chatListStyled";
import {
    ChatBox,
    Header,
    MessagesContainer,
    ChatInputContainer
} from "src/scenes/Chat/components/styled/chatMessagesStyled";
import ChatSkeletonTheme from "./ChatSkeletonTheme";

const ChatPageSkeleton = () => {
    return (
        <ChatSkeletonTheme>
            <MainContainer>
                <LeftContainer>
                    <SidebarSkeleton />
                </LeftContainer>
                <RightContainer>
                    <MessagePanelSkeleton />
                </RightContainer>
            </MainContainer>
        </ChatSkeletonTheme>
    );
};

const SidebarSkeleton = () => {
    return (
        <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <CompanyLogoContainer>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginTop: "-10px" }}>
                    <Skeleton circle height="2.75rem" width="2.75rem" />
                    <Skeleton height="1rem" width="1rem" />
                </div>
            </CompanyLogoContainer>

            <div style={{ padding: "0 0.9375rem" }}>
                <Skeleton height="2.5rem" width="100%" style={{ margin: "1.4375rem 0 0.8rem 0" }} />
                <Skeleton height="2.5rem" width="100%" style={{ margin: "0 0 0.8rem 0" }} />
            </div>

            <ChatListScrollableContainer style={{ flex: 1 }}>
                {Array.from({ length: 10 }).map((_, index) => (
                    <li key={index} style={{ display: "flex", alignItems: "center", padding: "0.5rem 0", listStyle: "none" }}>
                        <Skeleton circle height={50} width={50} style={{ marginRight: "1rem" }} />
                        <div style={{ flex: 1 }}>
                            <Skeleton height={24} width="80%" />
                            <Skeleton height={18} width="60%" />
                        </div>
                    </li>
                ))}
            </ChatListScrollableContainer>
        </div>
    );
};

const MessagePanelSkeleton = () => {
    return (
        <ChatBox>
            <Header>
                <div style={{ display: "flex", alignItems: "center", width: "70%" }}>
                    <div style={{ width: "60%" }}>
                        <Skeleton height={24} width="70%" />
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Skeleton height={24} width="11.4375rem" style={{ marginRight: "1.125rem" }} />
                    <Skeleton circle height="2.75rem" width="2.75rem" />
                </div>
            </Header>

            <MessagesContainer>
                {Array.from({ length: 8 }).map((_, index) => {
                    const isOwnMessage = index % 3 === 0;
                    return (
                        <div
                            key={index}
                            style={{
                                alignSelf: isOwnMessage ? "flex-end" : "flex-start",
                                width: isOwnMessage ? "48%" : "58%",
                                margin: "0.625rem 0"
                            }}
                        >
                            <Skeleton height={18} width={isOwnMessage ? "50%" : "38%"} />
                            <Skeleton height={46} width="100%" borderRadius="1rem" />
                        </div>
                    );
                })}
            </MessagesContainer>

            <ChatInputContainer>
                <div className="input-container">
                    <Skeleton height="3.75rem" width="100%" borderRadius="1.875rem" />
                </div>
            </ChatInputContainer>
        </ChatBox>
    );
};

export default ChatPageSkeleton;
